<template>
  <div class="main-footer">
    <div class="footer-bg">
      <img src="@/assets/footer-bg-2.png" alt />
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-8">
          <div class="row">
            <div class="col-sm-4 mb-40">
              <h3>Company</h3>
              <ul>
                <li>
                  <a href="#">About kopplr</a>
                </li>
                <li>
                  <a href="#">Investor Relations</a>
                </li>
                <li>
                  <a href="#">Careers</a>
                </li>
                <li>
                  <a href="#">Newsroom</a>
                </li>
                <li>
                  <a href="#">Social Media</a>
                </li>
              </ul>
            </div>
            <div class="col-sm-4 mb-40">
              <h3>Industries</h3>
              <ul>
                <li>
                  <a href="#">Digital</a>
                </li>
                <li>
                  <a href="#">Retail</a>
                </li>
                <li>
                  <a href="#">eCommerce</a>
                </li>
                <li>
                  <a href="#">Financial Services</a>
                </li>
                <li>
                  <a href="#">Insurance</a>
                </li>
                <li>
                  <a href="#">Travel &amp; Recreation</a>
                </li>
              </ul>
            </div>
            <div class="col-sm-4 mb-40">
              <h3>Support</h3>
              <ul>
                <li>
                  <a href="#">Case Studies</a>
                </li>
                <li>
                  <a href="#">Insight</a>
                </li>
                <li>
                  <a href="#">Technical Knowledge</a>
                </li>
                <li>
                  <a href="#">Support</a>
                </li>
                <li>
                  <a href="#">Tutorials</a>
                </li>
                <li>
                  <a href="#">Payment Base</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-4 footer-widget-about">
          <logo :height="34" class="mb-20"></logo>
          <p class="mb-40">
            kopplr is an expertly designed merchant service provider platform, that offers an
            unparalleled onboarding and compliance experience which is automated to a maximum extend.
          </p>
          <h3>News and updates</h3>
          <newsletter-form></newsletter-form>
        </div>
      </div>
    </div>

    <bottom-bar></bottom-bar>
  </div>
</template>

<script>
import NewsletterForm from '@/components/NewsletterForm.vue'
import Logo from '@/components/header/Logo.vue'
import BottomBar from '@/components/BottomBar.vue'

export default {
  name: 'app-footer',
  components: {
    NewsletterForm,
    Logo,
    BottomBar
  }
}
</script>
